import { render, staticRenderFns } from "./comp-end-btn.vue?vue&type=template&id=d6e43a0e&scoped=true&lang=pug&"
import script from "./comp-end-btn.vue?vue&type=script&lang=js&"
export * from "./comp-end-btn.vue?vue&type=script&lang=js&"
import style0 from "./comp-end-btn.vue?vue&type=style&index=0&id=d6e43a0e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e43a0e",
  null
  
)

/* custom blocks */
import block0 from "./comp-end-btn.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports